<div class="vue-pan-zoom-item" :class="['vue-pan-zoom-item-' + this.instanceId]">
    <div class="vue-pan-zoom-scene">
        <slot></slot>
    </div>
</div>